<div class="flex justify-center items-center w-full mt-24 text-l font-semibold text-[#494950]">
  <div class="flex items-center gap-2 bg-card rounded-lg max-w-[400px] py-8 px-12">
    <app-activity-spinner
      [color]="'#494950'"
      [size]="'30px'"
    />
    <span>Bitte warten...</span>
  </div>
</div>
